import { ChangeDetectionStrategy, Component } from "@angular/core";
import { AnimationOptions, LottieComponent } from "ngx-lottie";

@Component({
  selector: "app-waves-background",
  standalone: true,
  imports: [LottieComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="overflow-hidden w-screen h-dvh fixed z-[-1] top-0 left-0 pointer-events-none opacity-50">
      <div class="flex flex-col w-full h-full justify-end">
        <div class="w-full rotate-180">
          <ng-lottie width="100%" [options]="wavesOptions"></ng-lottie>
        </div>
      </div>
    </div>
  `,
})
export class WavesBackgroundComponent {
  public readonly wavesOptions: AnimationOptions = {
    path: "/assets/lottie/waves.json",
    loop: true,
    autoplay: true,
  };
}
